export const countryParamName = 'country';
export const allCountriesValue = 'ALL';
